import React from "react";
import Navbar from "../components/HomeComps/Navbar";
import Footer from "../components/HomeComps/Footer";

const AwardsPage = () => {
  return (
    <div>
      <Navbar />
      <Footer />
    </div>
  );
};

export default AwardsPage;
